import { PrineConvertAdapter } from './PrineConvertAdapter';
import { PrineConvert } from './PrineConvert';
import { PrineConvertAdapterExport } from './PrineConvertAdapterExport';
import { PrineConvertExportData } from './types/PrineConvertExportData';

export class PrineConvertExport {
    private readonly data: PrineConvertExportData;

    constructor(data: PrineConvertExportData) {
        this.data = data;
    }

    using(implementation: PrineConvertAdapter): PrineConvertAdapterExport[] {
        return implementation.export(PrineConvert.cloneData(this.data));
    }
}
